import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsYogaNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.346 10.355l-.003-.001.012-.02 3.871-8.448a.624.624 0 01.013-.026C4.645 1.072 5.373.48 6.243.193a3.866 3.866 0 012.671.095c.845.35 1.522.994 1.859 1.813a2.993 2.993 0 01-.105 2.513L10.492 5h3.97c.94 0 1.566.973 1.175 1.829l-3.213 7.027A1.958 1.958 0 0110.644 15H3.55a3.84 3.84 0 01-1.464-.288c-.845-.35-1.522-.994-1.859-1.813a2.993 2.993 0 01.105-2.513zm8.091-8.911a2.616 2.616 0 00-1.802-.064c-.582.192-1.034.574-1.279 1.041L2.379 8.918l.025-.007a4.59 4.59 0 012.674.08c.68.235 1.276.637 1.673 1.173L9.538 4.08a1.744 1.744 0 00.08-1.505c-.2-.484-.617-.9-1.181-1.132zM5.99 11.478a1.162 1.162 0 00-.111-.354c-.188-.38-.6-.742-1.208-.951a3.34 3.34 0 00-1.936-.057c-.597.165-1.04.477-1.286.83a1.743 1.743 0 00-.066 1.478c.2.484.616.9 1.18 1.132.31.129.647.194.987.194h7.094a.708.708 0 00.644-.414L14.5 6.31a.038.038 0 00.005-.02.046.046 0 00-.008-.02.045.045 0 00-.015-.015.038.038 0 00-.02-.004H9.92L7.514 11.5a2.633 2.633 0 01-4.752.073l-.097-.194 1.12-.556.096.195a1.383 1.383 0 002.109.46z"
        fill=""
      />
    </svg>
  )
);
SvgSportsYogaNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsYogaNormalXsmall;
